import { render } from "./LoginForm.vue?vue&type=template&id=4675e150"
import script from "./LoginForm.js?vue&type=script&lang=yaml"
export * from "./LoginForm.js?vue&type=script&lang=yaml"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__